import classNames from 'clsx';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { TabView } from '@swf/poker';

import { usePokerSundayMillionWidget } from '../../model';
import { SundayMillionTab } from '../../types';
import MainEvent from '../MainEvent/MainEvent';
import Nav from '../Nav/Nav';
import Satellites from '../Satellites/Satellites';

import styles from './SundayMillion.scss';

const SundayMillion: React.FC = () => {
  const { widgetSelect, widgetDispatch } = usePokerSundayMillionWidget();
  const isLoading = useSelector(widgetSelect.isLoading);
  const tournamentsCount = useSelector(widgetSelect.getTournamentsCount);
  const selectedTab = useSelector(widgetSelect.getSelectedTab);
  const isDesktopEmbedded = useSelector(select.device.isDesktopEmbedded);
  const handleTabSelect = (tab: SundayMillionTab) => {
    widgetDispatch.changeTab({ tab });
  };

  useEffect(() => {
    widgetDispatch.setIsHydrated();
  }, [widgetDispatch]);

  return (
    <div
      className={classNames(styles.root, {
        [styles.empty]:
          selectedTab === SundayMillionTab.Satellites && !isLoading && !tournamentsCount
      })}
      data-desktop-embedded={isDesktopEmbedded}
    >
      <Nav selectedTab={selectedTab} onSelectTab={handleTabSelect} />
      <div className={styles.wrapper}>
        <TabView activeTab={selectedTab}>
          <TabView.Tab name={SundayMillionTab.Main}>
            <MainEvent />
          </TabView.Tab>
          <TabView.Tab name={SundayMillionTab.Satellites}>
            <Satellites />
          </TabView.Tab>
        </TabView>
      </div>
    </div>
  );
};

export default SundayMillion;
